import React, { useState } from 'react';
import moment from 'moment';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

const RescheduleDetails = ({ rescheduleData, isExpanded = false }) => {
  // Handle edge cases - if no data or empty object, return simple display
  if (!rescheduleData || typeof rescheduleData !== 'object' || Array.isArray(rescheduleData)) {
    return <Typography variant="body2" sx={{ color: 'grey.700', p: 1 }}>--</Typography>;
  }

  // Verify that rescheduleData contains valid entries
  let rescheduleEntries = [];
  try {
    rescheduleEntries = Object.entries(rescheduleData);
    if (rescheduleEntries.length === 0) {
      return <Typography variant="body2" sx={{ color: 'grey.700', p: 1 }}>--</Typography>;
    }
  } catch (error) {
    console.error('Error processing reschedule data:', error);
    return <Typography variant="body2" sx={{ color: 'grey.700', p: 1 }}>--</Typography>;
  }

  // When expanded inline in table, show full table
  if (isExpanded) {
    return (
      <Box>
        <TableContainer>
          <Table size="small" sx={{ whiteSpace: 'nowrap' }}>
            <TableHead>
              <TableRow sx={{ backgroundColor: 'grey.100' }}>
                <TableCell sx={{ color: 'grey.600', fontWeight: 700, fontSize: '12px', py: 1 }}>Attempt</TableCell>
                <TableCell align="center" sx={{ color: 'grey.600', fontWeight: 700, fontSize: '12px', py: 1 }}>PTTS</TableCell>
                <TableCell align="center" sx={{ color: 'grey.600', fontWeight: 700, fontSize: '12px', py: 1 }}>Pulse</TableCell>
                <TableCell align="center" sx={{ color: 'grey.600', fontWeight: 700, fontSize: '12px', py: 1 }}>TTS</TableCell>
                <TableCell align="center" sx={{ color: 'grey.600', fontWeight: 700, fontSize: '12px', py: 1 }}>Value</TableCell>
                <TableCell sx={{ color: 'grey.600', fontWeight: 700, fontSize: '12px', py: 1 }}>Start Date</TableCell>
                <TableCell sx={{ color: 'grey.600', fontWeight: 700, fontSize: '12px', py: 1 }}>Complete Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rescheduleEntries.map(([key, data], index) => (
                <TableRow 
                  key={key} 
                  sx={{ 
                    backgroundColor: index % 2 === 0 ? 'transparent' : 'rgba(0, 0, 0, 0.02)',
                    '&:hover': { backgroundColor: 'rgba(33, 150, 243, 0.08)' },
                    borderBottom: '1px solid',
                    borderColor: 'grey.200',
                  }}
                >
                  <TableCell sx={{ color: 'grey.700', fontSize: '12px', py: 1, fontWeight: 600 }}>{key}</TableCell>
                  <TableCell align="center" sx={{ color: 'grey.700', fontSize: '12px', py: 1 }}>{data?.used_ptts ?? 0}</TableCell>
                  <TableCell align="center" sx={{ color: 'grey.700', fontSize: '12px', py: 1 }}>{data?.used_pulse ?? 0}</TableCell>
                  <TableCell align="center" sx={{ color: 'grey.700', fontSize: '12px', py: 1 }}>{data?.used_tts ?? 0}</TableCell>
                  <TableCell align="center" sx={{ color: 'grey.700', fontSize: '12px', py: 1 }}>{data?.used_value ?? 0}</TableCell>
                  <TableCell sx={{ color: 'grey.700', fontSize: '12px', py: 1 }}>
                    {data?.start_date ? moment(data.start_date * 1000).format('D MMM, YYYY HH:mm') : '--'}
                  </TableCell>
                  <TableCell sx={{ color: 'grey.700', fontSize: '12px', py: 1 }}>
                    {data?.complete_date ? moment(data.complete_date * 1000).format('D MMM, YYYY HH:mm') : '--'}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  }

  // For compact cell display (non-expanded)
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', color: 'grey.700', gap: 0.5 }}>
      <Typography variant="body2" sx={{ fontSize: '12px', fontWeight: 500 }}>
        {rescheduleEntries.length}
      </Typography>
    </Box>
  );
};

export default RescheduleDetails;
